import { render, staticRenderFns } from "./edit_cnab_remittance_config.vue?vue&type=template&id=a7a85acc&scoped=true"
import script from "./edit_cnab_remittance_config.vue?vue&type=script&lang=js"
export * from "./edit_cnab_remittance_config.vue?vue&type=script&lang=js"
import style0 from "./edit_cnab_remittance_config.vue?vue&type=style&index=0&id=a7a85acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a85acc",
  null
  
)

export default component.exports